<template>
  <div class="d-flex flex-column">
    <span class="pb-7">К сожалению, на данный момент врачи выбранной Вами специальности отсутствуют.</span>
    <span class="pb-7">Узнать о ближайшей записи можно по телефону:</span>
    <div class="d-flex flex-row">
      <v-icon color="#8DCDC1">$phone</v-icon>
      <span class="pl-6">49-03-49</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoctorNotAvailablePanel"
}
</script>

<style scoped>

</style>